import React from "react";
import {Col, ColorPicker, Row, Space} from "antd";
import {ColumnProps} from "antd/es/table";
import Moment from "moment";
const columns: ColumnProps<any>[] = [
  {key: "1", title: "Mã NCC", dataIndex: "id", width: 80},
  {key: "2", title: "Tên NCC", dataIndex: "name", align: "left"},
  {key: "3", title: "Địa chỉ", dataIndex: "address", align: "left"},
  {
    key: "4",
    title: "Liên hệ",
    dataIndex: "address",
    align: "left",
    render(value, record, index) {
      return (
        <>
          {record.email ? `${record["email"]} - ` : ""} {record?.phone}
        </>
      );
    },
  },
  {key: "5", title: "Ghi chú", dataIndex: "description", align: "left"},
  {key: "6", title: "Thao tác", dataIndex: "action", width: 100},
];
export {columns};
